import React from 'react';
import PropTypes from 'prop-types';
import { openTab } from '../../../src/utils/openTab';
import FSFlatButton from '../../../src/components/lib/FSFlatButton';

const CiriumLink = 'https://www.cirium.com/studios/reports/on-time-performance/?cmpid=ilc%7Cbrand%7C2021-global-monthly-otp&sfid=77014G000001e6n2QA';

const title = 'THE ON-TIME PERFORMANCE REPORT';

const CiriumOTPSection = (props) => {
  const {
    reportButtonPress,
  } = props;

  return (
    <div className='homepage-cirium-otp-section'>
      <div className='homepage-cirium-otp-section-left-col'>
        <div className='homepage-cirium-otp-section-text-container'>
          <h3>{title}</h3>
        </div>
        <div className='homepage-cirium-otp-section-left-col-container'>
          <div className='homepage-cirium-otp-section-poster-container'>
            <img src='//assets.flightstats.com/v2/home/watch-cover-1.jpg' />
            <img src='//assets.flightstats.com/v2/home/watch-cover-2.jpg' />
          </div>
          <div className='homepage-cirium-otp-section-button-container'>
            <FSFlatButton
              href={CiriumLink}
              backgroundColor='#00856C'
              label='DOWNLOAD MONTHLY REPORTS'
              onClick={(e) => {
                e.preventDefault();
                reportButtonPress('CiriumOTP2021');
                openTab(CiriumLink);
              }}
            />
          </div>
        </div>
      </div>
      <div className='homepage-cirium-otp-section-right-col' />
    </div>
  );
};

CiriumOTPSection.propTypes = {
  reportButtonPress: PropTypes.func,
};

export default CiriumOTPSection;



// WEBPACK FOOTER //
// ./modules/Homepage/components/CiriumOTPSection.js